<template>
  <div
    class="box"
    v-loading="true"
    element-loading-text="登录中..."
    element-loading-background="rgba(255, 255, 255, 255)"
  ></div>
</template>

<script>
import { LoginSSOAPI, getSyncLogin } from '@/axios/login'
export default {
  name: 'intermediate',
  data() {
    return {
      token: '',
    }
  },
  created() {
    if (this.$route.query.rcode) {
      sessionStorage.setItem('shortFshort', this.$route.query.rcode)
    }
    if (this.$route.query.token) {
      this.token = this.$route.query.token || ''
      this.getSyncLoginFn()
    } else {
      this.$router.replace({ path: '/' })
    }
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  methods: {
    getSyncLoginFn() {
      getSyncLogin({ token: this.token })
        .then(async res => {
          if (res.status == 1) {
            LoginSSOAPI({ token: res.data.sso[0].token }).then(res => {
              if (res.status == 1) {
                localStorage.setItem('shortToken', res.data.authtoken)
              }
            })
            setTimeout(() => {
              this.toComplete()
            }, 600)
          }
        })
        .catch(err => {})
    },
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100vh;
}
::v-deep .el-loading-spinner {
  .el-loading-text {
    color: #f67942;
  }
  .circular {
    width: 28px;
    height: 28px;
  }
}
</style>
